import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'

import Form from './Form'
import ActionGet from '../../store/action/TemplateSender/Fetch'

import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import CustomGrid from "../../infra/components/grid/custom-grid-without-search";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Mapping Template Sender",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),
            searchForm : fromJS({
                "client-id"     : '',
            }),
            search: fromJS([
                { widthClass:'col-sm-12',id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "col-sm-4", field: "client-name", caption: "Client Name", allowSearch: true },
                { className : "col-sm-2", field: "sender", caption: "Sender", allowSearch: true },
                // { className : "col-sm-2", field: "namespace", caption: "Namespace", allowSearch: true },
                { className : "col-sm-2", field: "templateDetail", caption: "List Template", allowSearch: true },
                { className : "col-sm-1", cfield: "action", caption: "Actions", allowView: true, allowEdit: false, allowDelete: false }
            ],
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        // this.handleEditClicked = this.handleEditClicked.bind(this);
        // this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        //new
        this.handleFind = this.handleFind.bind(this);
    }

    componentDidMount(){
        this.props.actionGetAllClient()
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);

        if(field === 'client-id'){
            this.props.actionGetAllSender(value);
        }
        this.setState({ searchForm:formVal })
    }

    handleCancelForm(refresh){
        if(refresh){
            //new
            this.handleFindSearch(1);
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    // handleEditClicked = (value) => {
    //     this.setState({
    //         form:  fromJS({
    //             show: true,
    //             actionType: IsEdit,
    //             item: value
    //         })
    //     })
    // }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    // async handleRemoveClicked(value){
    //     var body = {
    //         "data":{
    //             "id":value.get('client-name')
    //         }
    //     };
    //     //debugger;
    //     // var temp = await this.props.actionDelete(body);
    //     // if(temp.ok){
    //     //     toast.success('Delete '+ value.get('priority-name') +' Success!', toast.POSITION.TOP_RIGHT)
    //     //     this.handleFindSearch(1);
    //     // }else{
    //     //     toast.error('Delete '+ value.get('priority-name') +' Failed!', toast.POSITION.TOP_RIGHT)
    //     // }
    // }

    refreshGrid(page, search){
        //new
        this.handleFindSearch(page);
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.templatesender ? fromJS(this.props.templatesender) : fromJS({});

            return (
                <CustomGrid
                    title="Setting Template Sender"
                    columns={ this.state.columns  }
                    items={ items }
                    search={ this.state.search }
                    handleSearch={ this.handleSearch }
                    handleViewClicked={this.handleViewClicked}
                    // handleEditClicked={this.handleEditClicked}
                    // handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                    // handleNew={ this.handleNew }
                >
                </CustomGrid>
            )
        }
    }

    handleFind(){
        this.handleFindSearch(1);
    }

    handleFindSearch(page){
        const {searchForm} = this.state;
        let client_id = searchForm.get('client-id');

        // let res = null;
        let sender = [""];
        let namespace="";
        var bodyFInd = {};
        this.props.actionGetAllSender(client_id)
        setTimeout(() => {
            bodyFInd = {
                "client-id" : client_id,
                "sender-id" : sender,
                "namespace": namespace
            }

            this.props.actionGet(page,this.state.sortForm, bodyFInd);

        }, 3000);
    }

    render(){
        const { form, searchForm } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add"  : "Edit"  ) : "Setting Mapping Template Sender";
        const  classHide  = title == "Setting Mapping Template Sender" ? 'card show' : 'card hidden';
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                </div>
                <div className=  {classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Client"
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success"
                                        onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success content-add"
                                        onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
  (state) => {
      return {
          templateall: state.user.templateall,
          clientall: state.user.clientall,
          senderall: state.user.senders,
          // sendernamespace: state.user.sendernamespace,
          templatesender:state.user.templatesender
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      // actionDelete: ActionDelete,
      actionGetAllClient:ActionGetAllClient,
      actionGetAllSender: ActionGetAllSender,

  }, dispatch),
)(Page);